import * as React from 'react';
import { resolve } from "inversify-react";
import autobind from "autobind-decorator";

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { DialogService } from "src/core/services/ui/dialog.service";
import { RulesListView } from "./rules-list.view";
import { RulesListDataService } from "./rules-list.data";
import { FormatService } from 'src/core/services/format.service';
import { ContextService } from 'src/core/services/context.service';
import { observer } from 'mobx-react';

@observer
export class RulesListController extends React.Component<ControllerProps<any>, any> {
	protected dataService: RulesListDataService;

	@resolve
	contextService: ContextService;

	@resolve
	formatService: FormatService;

	@resolve
	protected dialogService: DialogService;

	@resolve
	protected toast: ToastNotifications;

	public constructor(props) {
		super(props);
	}

	public componentDidMount() {
		this.dataService = RulesListDataService.make(this.contextService, this.formatService);
		this.loadData();
	}

	@autobind
	protected onItemDoubleClicked(item: RuleSummary) {
		this.props.history.push(`/rules/rules/${item == null ? 'new' : item.id }`);
	}

	@autobind
	protected gotoStackTrace(ruleId: number) {
		this.props.history.push(`/rules/stacktrace/${ruleId}`);
	}

	@autobind
	protected loadData() {
		this.props.setBusy(true);
		this.dataService.addSorting('id', 'asc', true);
		this.dataService.addFilter('isDeleted', 'eq', false);
		this.dataService.load(query => query)
			.then(() => this.props.setBusy(false))
			.catch(error => {
				this.props.setBusy(false)
				this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
			});
	}

	public render() {


		if (!this.dataService)
			return null;

		return <RulesListView
			model={this.dataService}
			setBusy={this.props.setBusy}
			gotoStackTrace={this.gotoStackTrace}
			onItemDoubleClicked={this.onItemDoubleClicked}
			onReload={this.loadData}
			{...this.props } />
	}
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/list/rules-list.controller.tsx